import Image from 'next/image'

import ContactForm from './contact-form'

const ContactView = () => {
  return (
    <main className="relative">
      {/* 左上の装飾画像 */}
      <div className="pointer-events-none absolute left-0 top-0">
        <span className="md:hidden">
          <Image
            src="/images/contact/record.png"
            alt=""
            width={180}
            height={180}
          />
        </span>
        <span className="hidden md:block">
          <Image
            src="/images/contact/record.png"
            alt=""
            width={320}
            height={320}
          />
        </span>
      </div>

      {/* 右上の装飾画像（デスクトップのみ） */}
      <div className="pointer-events-none absolute right-0 top-0 hidden md:block">
        <Image
          src="/images/contact/operator.png"
          alt=""
          width={320}
          height={320}
        />
      </div>
      <div className="mx-auto max-w-[640px] overflow-hidden px-4 pb-60 pt-18">
        <h1 className="mb-18 text-center text-2xl font-bold md:text-3xl">お問い合わせ</h1>
        <ContactForm />
      </div>
    </main>
  )
}

export default ContactView
